import {
    useEffect,
    useState
} from "react";

import {
    useParams,
    useNavigate
} from "react-router-dom";

import API from "../../services/api";

function ViewSalesReturn() {

    const { id } =
        useParams();

    const navigate =
        useNavigate();

    const [salesReturn,
        setSalesReturn] =
        useState(null);

    const [items,
        setItems] =
        useState([]);

    useEffect(() => {

        loadSalesReturn();

    }, []);

    const loadSalesReturn =
        async () => {

            try {

                const token =
                    localStorage.getItem(
                        "adminToken"
                    );

                const res =
                    await API.get(
                        `/sales-returns/${id}`,
                        {
                            headers: {
                                Authorization:
                                    `Bearer ${token}`
                            }
                        }
                    );

                setSalesReturn(
                    res.data.salesReturn
                );

                setItems(
                    res.data.items || []
                );

            } catch (err) {

                console.log(err);

            }

        };

    const printInvoice = () => {

        setTimeout(() => {

            window.print();

        }, 300);

    };

    if (!salesReturn) {

        return (

            <div
                className="
        flex
        justify-center
        items-center
        h-[300px]
        text-xl
        "
            >
                Loading...
            </div>

        );

    }



    return (
        <>
            <style>
                {`
@media print{

    body *{
        visibility:hidden;
    }

    #print-area,
    #print-area *{
        visibility:visible;
    }

    #print-area{

        position:absolute;
        left:0;
        top:0;
        width:100%;
        background:#fff !important;
        color:#000 !important;
        padding:25px;

    }

    .no-print{
        display:none !important;
    }

    table{
        width:100%;
        border-collapse:collapse;
    }

    th,
    td{
        border:1px solid #000;
        padding:8px;
    }

    @page{
        size:A4;
        margin:12mm;
    }

}
`}
            </style>


            <div>

                {/* Header */}

                <div
                    className="
        flex
        justify-between
        items-center
        flex-wrap
        gap-4
        mb-8
        no-print
        "
                >

                    <div>

                        <h1
                            className="
            text-4xl
            font-bold
            "
                        >
                            Sales Return Invoice
                        </h1>

                        <p
                            className="
            text-gray-400
            mt-2
            "
                        >
                            View Returned Sales Invoice
                        </p>

                    </div>

                    <div
                        className="
          flex
          gap-3
          "
                    >

                        <button
                            onClick={
                                printInvoice
                            }
                            className="
            bg-blue-500
            px-6
            py-3
            rounded-xl
            "
                        >
                            Print
                        </button>

                        <button
                            onClick={() =>
                                navigate(
                                    "/admin/sales-returns"
                                )
                            }
                            className="
            bg-yellow-500
            text-black
            px-6
            py-3
            rounded-xl
            font-semibold
            "
                        >
                            Back
                        </button>

                    </div>

                </div>

                {/* Invoice */}

                <div
                    id="print-area"
                    className="
    bg-[#111]
    rounded-2xl
    p-8
    "
                >
                    {/* Company & Return Header */}

                    <div
                        className="
    flex
    justify-between
    items-start
    flex-wrap
    gap-8
    border-b
    border-yellow-500/20
    pb-8
    "
                    >

                        {/* Company */}

                        <div>

                            {salesReturn.logo && (
                                <img
                                    src={`${process.env.REACT_APP_API_URL}/uploads/${salesReturn.logo}`}
                                    alt=""
                                    className="w-20 h-20 object-contain mb-4"
                                />
                            )}

                            <h2 className="text-3xl font-bold">
                                {salesReturn.company_name}
                            </h2>

                            <p>{salesReturn.company_address}</p>

                            <p>
                                Phone : {salesReturn.company_phone}
                            </p>

                            <p>
                                Email : {salesReturn.company_email}
                            </p>

                            <p>
                                GST : {salesReturn.gst_number}
                            </p>

                        </div>

                        {/* Return Info */}

                        <div
                            className="
        text-right
        "
                        >

                            <h2
                                className="
            text-2xl
            font-bold
            text-red-500
            "
                            >
                                SALES RETURN
                            </h2>

                            <p className="mt-3">

                                <strong>
                                    Return No :
                                </strong>

                                {" "}

                                {
                                    salesReturn.return_no
                                }

                            </p>

                            <p className="mt-2">

                                <strong>
                                    Date :
                                </strong>

                                {" "}

                                {
                                    new Date(salesReturn.created_at).toLocaleString()
                                }

                            </p>

                            <p className="mt-2">

                                <strong>
                                    Wallet :
                                </strong>

                                {" "}

                                {
                                    salesReturn.wallet_name
                                }

                            </p>

                            {
                                salesReturn.invoice_id && (

                                    <p className="mt-2">

                                        <strong>
                                            Invoice ID :
                                        </strong>

                                        {" "}

                                        #
                                        {
                                            salesReturn.invoice_id
                                        }

                                    </p>

                                )
                            }

                            <p><strong>Invoice :</strong> {salesReturn.invoice_no}</p>

                            <p><strong>Refund Type :</strong> {salesReturn.refund_type}</p>

                            <p><strong>Created By :</strong> {salesReturn.created_by}</p>

                        </div>

                    </div>

                    {/* Customer Details */}

                    <div
                        className="
    grid
    md:grid-cols-2
    gap-8
    mt-8
    mb-8
    "
                    >

                        <div>

                            <h3
                                className="
            text-xl
            font-bold
            mb-4
            "
                            >
                                Customer Details
                            </h3>

                            <p>

                                <strong>
                                    Name :
                                </strong>

                                {" "}

                                {
                                    salesReturn.customer_name
                                }

                            </p>

                            <p className="mt-2">

                                <strong>
                                    Phone :
                                </strong>

                                {" "}

                                {
                                    salesReturn.phone
                                }

                            </p>

                            <p className="mt-2">

                                <strong>
                                    Email :
                                </strong>

                                {" "}

                                {
                                    salesReturn.email || "-"
                                }

                            </p>

                            <p className="mt-2">

                                <strong>
                                    Address :
                                </strong>

                                {" "}

                                {
                                    salesReturn.address || "-"
                                }

                            </p>

                        </div>

                        <div>

                            <h3
                                className="
            text-xl
            font-bold
            mb-4
            "
                            >
                                Return Details
                            </h3>

                            <p>

                                <strong>
                                    Refund Wallet :
                                </strong>

                                {" "}

                                {
                                    salesReturn.wallet_name
                                }

                            </p>

                            <p className="mt-2">

                                <strong>
                                    Sub Total :
                                </strong>

                                {" "}

                                ₹
                                {
                                    Number(
                                        salesReturn.subtotal
                                    ).toFixed(2)
                                }

                            </p>

                            <p className="mt-2">

                                <strong>
                                    GST :
                                </strong>

                                {" "}

                                ₹
                                {
                                    Number(
                                        salesReturn.gst_total
                                    ).toFixed(2)
                                }

                            </p>

                            <p className="mt-2">

                                <strong>
                                    Grand Total :
                                </strong>

                                {" "}

                                ₹
                                {
                                    Number(
                                        salesReturn.grand_total
                                    ).toFixed(2)
                                }

                            </p>

                        </div>

                    </div>

                    {
                        salesReturn.reason && (

                            <div
                                className="
            mb-8
            bg-red-500/10
            border
            border-red-500/20
            rounded-xl
            p-4
            "
                            >

                                <h3
                                    className="
                font-semibold
                mb-2
                "
                                >
                                    Return Reason
                                </h3>

                                <p>
                                    {
                                        salesReturn.reason
                                    }
                                </p>

                            </div>

                        )
                    }

                    {/* Items Table Starts */}

                    <div
                        className="
    overflow-x-auto
    "
                    >

                        <table
                            className="
    w-full
    "
                        >

                            <thead>

                                <tr
                                    className="
    border-b
    border-yellow-500/20
    "
                                >

                                    <th className="p-3 text-left">
                                        Product
                                    </th>

                                    <th className="p-3 text-left">
                                        Qty
                                    </th>

                                    <th className="p-3 text-left">
                                        Price
                                    </th>

                                    <th className="p-3 text-left">
                                        GST %
                                    </th>

                                    <th className="p-3 text-left">
                                        Amount
                                    </th>

                                </tr>

                            </thead>

                            <tbody>
                                {items.length > 0 ? (

                                    items.map(
                                        (
                                            item,
                                            index
                                        ) => (

                                            <tr
                                                key={index}
                                                className="
                border-b
                border-yellow-500/10
                "
                                            >

                                                <td className="p-3">
                                                    {item.name}
                                                </td>

                                                <td className="p-3">
                                                    {item.qty}
                                                </td>

                                                <td className="p-3">
                                                    ₹
                                                    {Number(
                                                        item.price
                                                    ).toFixed(2)}
                                                </td>

                                                <td className="p-3">
                                                    {item.gst_percent}%
                                                </td>

                                                <td
                                                    className="
                    p-3
                    font-semibold
                    "
                                                >
                                                    ₹
                                                    {Number(
                                                        item.amount
                                                    ).toFixed(2)}
                                                </td>

                                            </tr>

                                        )
                                    )

                                ) : (

                                    <tr>

                                        <td
                                            colSpan="5"
                                            className="
            p-6
            text-center
            text-gray-400
            "
                                        >
                                            No Products Found
                                        </td>

                                    </tr>

                                )}

                            </tbody>

                        </table>

                    </div>

                    {/* Totals */}

                    <div
                        className="
    mt-10
    flex
    justify-end
    "
                    >

                        <div
                            className="
        w-full
        md:w-96
        bg-black
        print:bg-white
        border
        border-yellow-500/20
        rounded-2xl
        p-6
        "
                        >

                            <div
                                className="
            flex
            justify-between
            mb-4
            "
                            >

                                <span>
                                    Sub Total
                                </span>

                                <span>
                                    ₹
                                    {Number(
                                        salesReturn.subtotal
                                    ).toFixed(2)}
                                </span>

                            </div>

                            <div
                                className="
            flex
            justify-between
            mb-4
            "
                            >

                                <span>
                                    GST
                                </span>

                                <span>
                                    ₹
                                    {Number(
                                        salesReturn.gst_total
                                    ).toFixed(2)}
                                </span>

                            </div>

                            <div className="flex justify-between mb-4">
                                <span>Discount</span>

                                <span>
                                    ₹{Number(
                                        salesReturn.discount || 0
                                    ).toFixed(2)}
                                </span>
                            </div>

                            <div
                                className="
            flex
            justify-between
            border-t
            border-yellow-500/20
            pt-4
            text-2xl
            font-bold
            text-red-500
            "
                            >

                                <span>
                                    Grand Total
                                </span>

                                <span>
                                    ₹
                                    {Number(
                                        salesReturn.grand_total
                                    ).toFixed(2)}
                                </span>

                            </div>

                        </div>

                    </div>

                    {/* Footer */}

                    <div
                        className="
mt-8
border-t
pt-4
"
                    >

                        <div
                            className="
grid
grid-cols-2
gap-10
"
                        >

                            <div>

                                <h3
                                    className="
font-bold
text-lg
mb-3
"
                                >
                                    Terms & Conditions
                                </h3>

                                <p
                                    className="
text-sm
leading-7
text-gray-400
print:text-gray-700
"
                                >
                                    {salesReturn.invoice_footer ||
                                        "Goods once returned cannot be exchanged again."}
                                </p>

                                <p
                                    className="
mt-4
text-sm
text-gray-400
print:text-gray-700
"
                                >
                                    This is a computer generated Sales Return.
                                    No signature is required.
                                </p>

                            </div>

                            <div
                                className="
text-right
flex
flex-col
justify-end
"
                            >

                                <div>

                                    <h3
                                        className="
font-bold
text-center
ml-auto
w-56
"
                                    >
                                        {salesReturn.company_name}
                                    </h3>

                                </div>

                                <div
                                    className="
border-t
border-black
inline-block
pt-2
w-56
text-center
ml-auto
"
                                >

                                    Authorized Signature

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>
        </>

    );

}

export default ViewSalesReturn;